/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav Issues Icon component.
 */
export const SideNavIssuesIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='SideNavIssuesIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M17.255 17.828V11.86c0-2.703-2.415-4.895-5.394-4.895S6.467 9.157 6.467 11.86v5.968'
          stroke={iconColor}
          strokeWidth={1.5} />
        <rect x={4.439}
          y={18.058}
          width={14.844}
          height={3.362}
          rx={1.131}
          stroke={iconColor}
          strokeWidth={1.5} />
        <path d='M3.45 11.606H1M5.731 6.294L4 4.722M22.17 11.606h-2.45M11.585 2v2.223M16.996 6.294l1.732-1.572'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeLinecap='round' />
      </svg>
    )} />
  );
};
